module.exports = __webpack_public_path__ + "static/media/4-5.43af27c4.png";